// src/components/quality/view/QualityNCView.jsx
import PeopleView from "../../common/people/PeopleView";
import TableCell from "../../common/ui/TableCell";

export default function QualityNCView({ data }) {
  if (!data) return null;

  const header = data.header || {};
  const ncr = data.ncr || {};

  return (
    <div className="space-y-6">

      {/* 기본정보 */}
      <table className="w-full border text-sm">
        <colgroup>
          <col style={{ width: "120px" }} />
          <col />
          <col style={{ width: "120px" }} />
          <col />
        </colgroup>
        <tbody>
          <tr>
            {/* <TableCell label="제목" value={header.title || "-"} /> */}
            <TableCell label="발생일" value={header.doc_date || "-"} />
            <TableCell label="발생장소" value={header.location || "-"} />
          </tr>

          
          <tr>
            <TableCell label="업체" value={header.vendor || "-"} />
            <TableCell label="부적합 유형" value={header.nc_type || "-"} />
          </tr>

          <tr>
            <TableCell label="최종판정" value={header.result || "-"} />
            <TableCell label="제안자" value={ncr.proposer || "-"} />
          </tr>
          <tr>
          <TableCell
            label="조치 담당자"
            colSpan={3}
            value={
              <PeopleView
                dns={data.doc_dns}
                // value={meta?.requestPeople || []} 
                placeholder="지정된 담당자 없음"
              />
            }
          />
          </tr>
        </tbody>
      </table>

      {/* 상세내용 */}
      <div>
        <h3 className="font-semibold mt-4 mb-1">부적합 내용</h3>
        <div className="border p-3 rounded">{ncr.description || "-"}</div>

        <h3 className="font-semibold mt-4 mb-1">즉시/임시조치</h3>
        <div className="border p-3 rounded">{ncr.immediate_action || "-"}</div>
      </div>
    </div>
  );
}
